import React from "react"
import DarkModeToggle from "./dark-mode-toggle"
import { Link } from "gatsby"

const Header: React.FC = () => {
  return (
    <div className="text-foreground-secondary font-logo mb-4 md:mb-8 relative">
      <DarkModeToggle className="absolute right-0 bottom-0 cursor-pointer" />
      <div className="w-min">
        <Link to="/">
          <h1 className="text-4xl">Chillburn Recordings</h1>
        </Link>
      </div>
      <ul className="flex text-background-test text-sm gap-4 mt-5 flex-wrap">
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/news">News</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
      </ul>
    </div>
  )
}

export default Header
